// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib__String from "melange/string.js";

const none = "";

function append(x1, x2) {
  if (x1 === "") {
    return x2;
  } else if (x2 === "") {
    return x1;
  } else {
    return x1 + (" " + x2);
  }
}

function fromList(param) {
  let _acc = "";
  let _param = param;
  while(true) {
    const param$1 = _param;
    const acc = _acc;
    if (!param$1) {
      return acc;
    }
    const cn = param$1.hd;
    if (cn === "") {
      _param = param$1.tl;
      continue ;
    }
    _param = param$1.tl;
    _acc = acc + (" " + cn);
    continue ;
  };
}

function on(cn, x) {
  if (x) {
    return cn;
  } else {
    return none;
  }
}

function onSome(cn, x) {
  if (x !== undefined) {
    return cn;
  } else {
    return none;
  }
}

function mapSome(x, fn) {
  if (x !== undefined) {
    return Curry._1(fn, Caml_option.valFromOption(x));
  } else {
    return none;
  }
}

function mapSomeU(x, fn) {
  if (x !== undefined) {
    return fn(Caml_option.valFromOption(x));
  } else {
    return none;
  }
}

function take(x) {
  if (x !== undefined) {
    return x;
  } else {
    return none;
  }
}

function onOk(cn, x) {
  if (x.TAG === /* Ok */0) {
    return cn;
  } else {
    return none;
  }
}

function mapOk(x, fn) {
  if (x.TAG === /* Ok */0) {
    return Curry._1(fn, x._0);
  } else {
    return none;
  }
}

function mapOkU(x, fn) {
  if (x.TAG === /* Ok */0) {
    return fn(x._0);
  } else {
    return none;
  }
}

function onErr(cn, x) {
  if (x.TAG === /* Ok */0) {
    return none;
  } else {
    return cn;
  }
}

function mapErr(x, fn) {
  if (x.TAG === /* Ok */0) {
    return none;
  } else {
    return Curry._1(fn, x._0);
  }
}

function mapErrU(x, fn) {
  if (x.TAG === /* Ok */0) {
    return none;
  } else {
    return fn(x._0);
  }
}

function make(cns) {
  return Stdlib__String.concat(" ", Belt__Belt_List.keep(cns, (function (x) {
                    return x !== "";
                  })));
}

function ifTrue(cn, x) {
  if (x) {
    return cn;
  } else {
    return "";
  }
}

function ifSome(cn, x) {
  if (x !== undefined) {
    return cn;
  } else {
    return "";
  }
}

function unpack(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "";
  }
}

const $plus = append;

const $less$colon$great = append;

export {
  $plus ,
  $less$colon$great ,
  append ,
  fromList ,
  none ,
  on ,
  onSome ,
  mapSome ,
  mapSomeU ,
  take ,
  onOk ,
  mapOk ,
  mapOkU ,
  onErr ,
  mapErr ,
  mapErrU ,
  make ,
  ifTrue ,
  ifSome ,
  unpack ,
}
/* No side effect */
